import { useState, useEffect } from 'react';
import Autocomplete from '@mui/joy/Autocomplete';
import { getAllRequest } from '@app/api/generic/generic';
import { getTablesParams } from '@app/api/apiType';
import axios from '@app/config/axios.config';

interface props {
    apiUrl: string;
    keyDisplay?: string;
    formatLabel?: (item: any) => string;
    dbSendKey?: string;
    onChange: (arg1: number | undefined | string) => void;
    initialId: number | null;
}

const SearchAutocomplete = ({
    apiUrl,
    keyDisplay,
    formatLabel,
    dbSendKey,
    onChange,
    initialId,
}: props) => {
    type OptionData = { id: number | null; label: string; value?: string };

    // Fonction utilitaire pour générer le label
    const generateLabel = (item: any): string => {
        if (formatLabel) {
            return formatLabel(item);
        }
        if (keyDisplay) {
            return item[keyDisplay] || '';
        }
        return '';
    };
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState<OptionData[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState<OptionData | null>(
        null
    );
    const [initialOption, setInitialOption] = useState<OptionData>({
        id: null,
        label: '',
        value: '',
    });

    useEffect(() => {
        if (initialId) {
            axios
                .get(`${apiUrl}/${initialId}`)
                .then((res) => {
                    console.log('res:', res);
                    const label = generateLabel(res.data);
                    console.log('generated label:', label);
                    setInitialOption({
                        id: initialId,
                        label: label,
                    });
                })
                .catch((err) => {
                    setInitialOption({
                        id: null,
                        label: initialId.toString(),
                    });
                });
        }
    }, [initialId]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            if (inputValue) {
                setLoading(true);
                const param: getTablesParams = {
                    page: 0,
                    limit: 5,
                    search: inputValue,
                    secondarySearch: '',
                    sort_by: '',
                    asc: false,
                    filters: [],
                };
                const result = (await getAllRequest(apiUrl, param)).result;
                setOptions(
                    result.map((item: any) => {
                        return {
                            id: item.id,
                            label: generateLabel(item),
                            value: dbSendKey ? item[dbSendKey] : '',
                        };
                    })
                );
                setLoading(false);
            } else {
                setOptions([]);
            }
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [inputValue]);

    const handleChange = (newValue: OptionData | null) => {
        console.log('newValue:', newValue);
        if (newValue !== null) {
            setSelectedOption(newValue);
            newValue.id && onChange(dbSendKey ? newValue.value : newValue.id);
        } else {
            setSelectedOption({ id: null, label: '', value: '' });
            onChange(undefined);
        }
    };

    return (
        <div>
            <Autocomplete
                size="sm"
                options={options}
                loading={loading}
                placeholder="Rechercher..."
                defaultValue={initialOption}
                value={selectedOption ? selectedOption : initialOption}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                    handleChange(newValue);
                }}
                onInputChange={(event, newValue) => {
                    setInputValue(newValue);
                }}
            />
        </div>
    );
};

export default SearchAutocomplete;
